<template>
  <div class="continueInApp">
    <!-- Иллюстрация: мобайл — телефон + лого; десктоп — телефон + QR (× поверх) -->
    <mq-responsive target="mobile-tablet" class="continueInApp_illustration">
      <ac-image :src="illustrationMobile" aspect-ratio="720 / 566" object-fit="cover" alt="" />
      <button
        class="continueInApp_close -onImage"
        data-test="continue-close"
        aria-label="Закрыть"
        @click="onClose('cross_button')"
      >
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_24929_239821)">
          <path d="M14 12.3502L18.9502 7.40003C19.4057 6.94449 20.1443 6.94449 20.5998 7.40003C21.0554 7.85557 21.0554 8.59415 20.5998 9.0497L15.6496 13.9999L20.5998 18.95C21.0554 19.4056 21.0554 20.1442 20.5998 20.5997C20.1443 21.0552 19.4057 21.0552 18.9502 20.5997L14 15.6495L9.04982 20.5997C8.59427 21.0552 7.85569 21.0552 7.40015 20.5997C6.94461 20.1442 6.94461 19.4056 7.40015 18.95L12.3503 13.9999L7.40015 9.0497C6.94461 8.59415 6.94461 7.85557 7.40015 7.40003C7.85569 6.94449 8.59427 6.94449 9.04982 7.40003L14 12.3502Z" fill="white"/>
          </g>
          <defs>
          <clipPath id="clip0_24929_239821">
          <rect width="28" height="28" fill="white"/>
          </clipPath>
          </defs>
        </svg>
      </button>
      <div class="continueInApp_illustrationGradient"></div>
    </mq-responsive>

    <mq-responsive target="desktop" class="continueInApp_illustration -desktop" data-test="continue-qr">
      <ac-image :src="illustrationDesktop" aspect-ratio="766 / 600" object-fit="cover" alt="" />
      <ac-image class="continueInApp_qr" :src="qrCode" :width="160" :height="160" :radius="12" object-fit="cover" alt="QR" />
      <button
        class="continueInApp_close -onImage"
        data-test="continue-close"
        aria-label="Закрыть"
        @click="onClose('cross_button')"
      >
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_24929_239821)">
          <path d="M14 12.3502L18.9502 7.40003C19.4057 6.94449 20.1443 6.94449 20.5998 7.40003C21.0554 7.85557 21.0554 8.59415 20.5998 9.0497L15.6496 13.9999L20.5998 18.95C21.0554 19.4056 21.0554 20.1442 20.5998 20.5997C20.1443 21.0552 19.4057 21.0552 18.9502 20.5997L14 15.6495L9.04982 20.5997C8.59427 21.0552 7.85569 21.0552 7.40015 20.5997C6.94461 20.1442 6.94461 19.4056 7.40015 18.95L12.3503 13.9999L7.40015 9.0497C6.94461 8.59415 6.94461 7.85557 7.40015 7.40003C7.85569 6.94449 8.59427 6.94449 9.04982 7.40003L14 12.3502Z" fill="white"/>
          </g>
          <defs>
          <clipPath id="clip0_24929_239821">
          <rect width="28" height="28" fill="white"/>
          </clipPath>
          </defs>
        </svg>
      </button>
      <div class="continueInApp_illustrationGradient"></div>
    </mq-responsive>

    <div class="continueInApp_content">
      <div class="continueInApp_head">
        <h2 class="continueInApp_title">{{ $t('postFirstDayModal.continueTitle') }}</h2>
        <p class="continueInApp_desc">{{ $t('postFirstDayModal.continueDesc') }}</p>
      </div>

      <ul class="continueInApp_benefits" data-test="continue-benefits">
        <li class="continueInApp_benefit">
          <span class="continueInApp_benefitIcon">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.98394 19.9997C8.10769 19.7964 7.26601 19.4615 6.48652 19.0061M13.012 1.99969C15.0142 2.46529 16.8017 3.60926 18.0821 5.24429C19.3624 6.87931 20.0596 8.90852 20.0596 10.9997C20.0596 13.0908 19.3624 15.1201 18.0821 16.7551C16.8017 18.3901 15.0142 19.5341 13.012 19.9997M3.52486 16.2221C2.97612 15.4091 2.55895 14.5117 2.28924 13.5642M2.05964 9.46157C2.22076 8.48744 2.53092 7.56457 2.96596 6.71861L3.13615 6.40586M5.86921 3.39014C6.81199 2.73068 7.86883 2.25889 8.98394 1.99969" stroke="var(--ac-color-blue)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.05964 10.9997L10.0596 12.9997L14.0596 8.99969" stroke="var(--ac-color-blue)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="continueInApp_benefitText">{{ $t('postFirstDayModal.benefitProgress') }}</span>
        </li>
        <li class="continueInApp_benefit">
          <span class="continueInApp_benefitIcon">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.66667 15.5833V17.4167C3.66667 17.9029 3.85982 18.3692 4.20364 18.713C4.54745 19.0568 5.01377 19.25 5.5 19.25H16.5C16.9862 19.25 17.4525 19.0568 17.7964 18.713C18.1402 18.3692 18.3333 17.9029 18.3333 17.4167V15.5833M15.5833 10.0833L11 14.6667L6.41667 10.0833M11 14.6667V3.66667" stroke="var(--ac-color-blue)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="continueInApp_benefitText">{{ $t('postFirstDayModal.benefitOffline') }}</span>
        </li>
        <li class="continueInApp_benefit">
          <span class="continueInApp_benefitIcon">
            <svg width="22" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.39 0.75H4.11C2.25432 0.75 0.75 2.20205 0.75 3.99324V17.5068C0.75 19.2979 2.25432 20.75 4.11 20.75H11.39C13.2457 20.75 14.75 19.2979 14.75 17.5068V3.99324C14.75 2.20205 13.2457 0.75 11.39 0.75Z" stroke="var(--ac-color-blue)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6.75 17.75H8.75" stroke="var(--ac-color-blue)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span class="continueInApp_benefitText">{{ $t('postFirstDayModal.benefitHandy') }}</span>
        </li>
      </ul>

      <div class="continueInApp_actions">
        <mq-responsive target="mobile-tablet">
          <ac-button block data-test="continue-cta" @click="onCta">
            {{ $t('postFirstDayModal.continueCta') }}
          </ac-button>
        </mq-responsive>
        <ac-button class="continueInApp_action -text" block variant="text" data-test="continue-stay" @click="onClose('secondary_button')">
          {{ $t('postFirstDayModal.stayInBrowser') }}
        </ac-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { MqResponsive } from 'vue3-mq'

import AcButton from '@ui-kit/components/AcButton.vue'
import AcImage from '@web/ui-kit/components/AcImage/index.vue'
import Token from '@web/common/token'
import { postFirstDayModalCtaClicked, postFirstDayModalRedirectApp } from '@web/services/Analytics/events'
import type { CloseMethod } from '@web/services/Analytics/events/postFirstDayModal'
import { buildOneLink } from './oneLink'
import illustrationDesktop from '@web/assets.v2/post-first-day/continue-illustration-desktop.jpg'
import illustrationMobile from '@web/assets.v2/post-first-day/continue-illustration-mobile.jpg'
import qrCode from '@web/assets.v2/post-first-day/qr-code.png'

const emit = defineEmits<{ close: [method: CloseMethod]; cta: [] }>()

// CTA существует только на мобайле (десктоп уводит через QR), поэтому platform_view фиксирован.
function onCta (): void {
  postFirstDayModalCtaClicked({ modalType: 'continue_in_app', platformView: 'mobile_web' })
  postFirstDayModalRedirectApp()
  window.open(buildOneLink(Token.get()), '_blank')
  emit('cta')
}

function onClose (method: CloseMethod): void {
  emit('close', method)
}
</script>

<style lang="scss" scoped>
@import '@web/assets/scss/textContents.scss';

.continueInApp {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 383px;
  max-height: 90dvh;
  background-color: var(--ac-color-white);
  border-radius: 12px 12px 0 0;
  overflow: hidden;

  @media (min-width: $screen-desktop) {
    border-radius: 12px;
  }

  &_illustration {
    position: relative;
    width: 100%;
    overflow: hidden;
  }

  &_qr {
    position: absolute;
    top: 50%;
    left: calc(50% + 96px);
    transform: translate(-50%, -50%);
    box-shadow: 0 0 6px 4px rgba(48, 14, 76, 0.08);
    border-radius: 12px;
    overflow: hidden;
    }

  &_close {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    line-height: 0;

    &.-onImage {
      position: absolute;
      top: 8px;
      right: 8px;
      z-index: 1;
    }
  }

  &_illustrationGradient {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 89px;
    background: linear-gradient(180deg, rgba(var(--ac-color-rgb-white), 0) 0%, var(--ac-color-white) 100%);
  }

  &_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 8px 20px 22px;
    box-sizing: border-box;
  }

  &_head {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
    text-align: center;
  }

  &_title {
    margin: 0;
    @extend .text-xl-medium;
    color: var(--ac-color-deep-navy-blue);

    @media (min-width: $screen-desktop) {
      @include text-size(22px, 1.27, 500);
    }
  }

  &_desc {
    margin: 0;
    @extend .text-sm;
    color: var(--ac-color-dark-gray);
    margin-bottom: 14px;
  }

  &_benefits {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    margin: 0;
    padding: 12px 18px 16px;
    list-style: none;
    background: var(--ac-color-white);
    border-radius: 26px;
    box-shadow: 0px 4px 10px 2px #2954FB1A;
    box-sizing: border-box;
  }

  &_benefit {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &_benefitIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 42px;
    height: 42px;
    background: var(--ac-color-bluesubstrate);
    border-radius: 12px;
  }

  &_benefitText {
    flex: 1;
    @extend .text-sm;
    color: #01050c;
    text-align: left;
  }

  &_actions {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }

  &_action {
    &.-text {
      color: var(--ac-color-deep-liliac);
    }
  }
}
</style>
